import React from "react"
import { Col, Row, Container } from "react-bootstrap"
import originalRoom from "../../img/image-1.png"
import generatedRoom from "../../img/image-2.png"
import "./BannerSection.css"
import {
  ReactCompareSlider,
  ReactCompareSliderImage,
} from "react-compare-slider"

interface roomComparisonProps { }

const RoomComparision = (props: roomComparisonProps) => {
  return (
    <>
      <Container>
        <Row className="justify-content-center">
          <Col md="12">
            <div className="original-room">
              <div className="room-heading">
              </div>
              <div className="room-image">
                <ReactCompareSlider
                  itemOne={<ReactCompareSliderImage src={generatedRoom} alt="generated room" />}
                  itemTwo={<ReactCompareSliderImage src={originalRoom} alt="original room" />}
                  className="border-0 room-compare-wrapper"  />
              </div>
            </div>
          </Col>
          {/* <Col md="6">
            <div className="generated-room">
              <div className="room-heading">
                <p>Generated Room</p>
              </div>
              <div className="room-image">
                <ReactCompareSlider
                  itemOne={<ReactCompareSliderImage src={generatedRoom} alt="generated room" />}
                  itemTwo={<ReactCompareSliderImage src={originalRoom} alt="original room" />}
                />
              </div>
            </div>
          </Col> */}
        </Row>

      </Container>
    </>
  )
}

export default RoomComparision
